import { render, staticRenderFns } from "./lkuItemLazzyCustPrice.vue?vue&type=template&id=33722e7a"
import script from "./lkuItemLazzyCustPrice.vue?vue&type=script&lang=js"
export * from "./lkuItemLazzyCustPrice.vue?vue&type=script&lang=js"
import style0 from "./lkuItemLazzyCustPrice.vue?vue&type=style&index=0&id=33722e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports